module.exports = __webpack_public_path__ + "img/user.3c44b87a.svg";